module.exports = __webpack_public_path__ + "static/media/L1.cc0fc82f.svg";